import { Alert, Box, Button, Typography } from '@mui/material';
import DevicePage from '../DevicePage';
import useDeviceData from '../../hooks/useDeviceData';
import MapComponent from './Map';
import { locationCoordinates, locationTime } from './LocationDetails';
import LocationTiles from './LocationTiles';
import DeviceLocationActions from './DeviceLocationActions';

function DeviceMap({ unit }) {
    const { data, status, reload, retry } = useDeviceData(unit);
    const location = data?.lastKnownLocation;
    const coordinates = locationCoordinates(location);
    return <Box sx={{ maxWidth: 800, mx: 'auto', px: 1, pb: 2 }}>
        {!unit?.UnitSerNum ? <Alert severity="info">Select a customer to view their device location.</Alert>
            : status === 'loading' ? <Typography role="status">Loading device location…</Typography>
                : status === 'error' ? <Alert severity="error" action={<Button color="inherit" onClick={retry}>Retry</Button>}>Unable to load device location. Check your connection and try again.</Alert>
                    : <>
                        {coordinates ? <MapComponent {...coordinates} address={location.address}
                            eventTime={locationTime(location.EventTime)} isUsingHomeLocation={data?.useHomeLocation} />
                            : <Alert severity="info">No saved coordinates are available for this device.</Alert>}
                        <Box sx={{ mt: 2 }}>
                            <LocationTiles location={location} isUsingHomeLocation={data?.useHomeLocation} showHome={false} />
                            <DeviceLocationActions unit={unit} data={data} reload={reload} />
                        </Box>
                    </>}
    </Box>;
}

export default function MapPage() {
    return <DevicePage content={DeviceMap} />;
}
